const trimTrailingSlashes = (value = "") => value.replace(/\/+$/, "");

const getRuntimeOrigin = () => {
  if (typeof window === "undefined") return "";
  return window.location.origin;
};

export const PUBLIC_SITE_URL = trimTrailingSlashes(
  import.meta.env.VITE_SITE_URL || getRuntimeOrigin() || "https://watchnod.com"
);

export const getPublicUrl = (path = "") => {
  if (/^https?:\/\//i.test(path)) return path;
  return `${PUBLIC_SITE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};
